import styled from "styled-components";

export const Container = styled.div`
	padding: 0.6rem 1rem;
`;
